var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.length
    ? _c("section", { staticClass: "latest-news" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.showTitle
              ? _c(
                  "z-caption",
                  {
                    staticClass: "u-bottom-margin--xl-important",
                    attrs: {
                      size: "xl",
                      tag: "h2",
                      href: "/" + this.$root.lang + "/press-center/news/",
                      uppercase: "",
                      weight: "900",
                    },
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.text.newsTitle) },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "slider",
              {
                staticClass: "latest-news__slider",
                attrs: {
                  "space-between": 48,
                  "last-empty": "",
                  "slides-per-view": "2.5",
                },
              },
              [
                _vm._l(_vm.data, function (item, index) {
                  return _c(
                    "slide",
                    { key: index, staticClass: "latest-news__slide" },
                    [_c("news-card", { attrs: { data: item } })],
                    1
                  )
                }),
                _vm._v(" "),
                _c("slide", { staticClass: "latest-news__slide" }),
              ],
              2
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }